import axios from 'axios';

class ReadingService {
  getCronTiner() {
    return axios.get('cron/next-run');
  }

  getPendingOrders(shiftId1, shiftId2) {
    return axios.get(`/ftp-readings/pending-orders/all/n/${shiftId1}/${shiftId2}`);
  }

  getFilteredReadings(regionId, shiftId1, shiftId2) {
    return axios.get(`/ftp-readings/reads/region/pending/${regionId}/${shiftId1}/${shiftId2}`);
  }

  getReadingsByRegion(regionId) {
    return axios.get(`/ftp-readings/reads/region/${regionId}`);
  }
}

export default new ReadingService();
